<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <div>
        <el-input
          v-model="objr.name"
          style="width:200px;margin-right:10px"
          placeholder="请输入名称"
        />
        <el-input
          v-model="objr.audience_id"
          style="width:200px;margin-right:10px"
          placeholder="请输入人群ID"
        />

        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
        <el-button
          type="warning"
          @click="deleteItem"
        >拉取人群包</el-button>
        <el-button
          class="filter-item"
          type="warning"
          @click="upbAdLog"
        >广告批量修改记录</el-button>
      </div>
      <!-- <div>
        <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button>
      </div> -->
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%;margin-top:20px"
    >
      <el-table-column
        prop="account_id"
        label="广告主id"
        width="150"
        align="center"
      />
      <el-table-column
        prop="audience_id"
        label="人群id"
        width="150"
        align="center"
      />

      <el-table-column
        prop="name"
        label="人群名称"
        align="center"
        width="180"
      />
      <el-table-column
        prop="user_count"
        label="用户覆盖数"
        align="center"
        width="180"
      />
      <el-table-column
        prop="app_id"
        label="微信appid"
        align="center"
        width="180"
      />
      <el-table-column
        prop="image_url"
        label="是否自动排除"
        align="center"
        width="150"
      >
        <template scope="scope">
          <el-switch
            v-model="scope.row.is_auth_exclude"
            active-text="开"
            inactive-text="关"
            :active-value="1"
            :inactive-value="0"
            @change="handleSwitchChange($event, scope.row.id)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="type_text"
        label="人群类型"
        align="center"
        width="180"
      />
      <el-table-column
        prop="source_text"
        label="人群来源"
        align="center"
        width="180"
      />
      <el-table-column
        label="关联公众号(阅文)"
        width="180"
        align="center"
      >
        <template #default="scope">
          <el-tooltip
            effect="dark"
            placement="top"
            :content="getAppNames(scope.row.yw_open_app).join('，')"
          >
            <div class="ellipsis-text">
              {{ getAppNames(scope.row.yw_open_app).slice(0, 2).join('，') }}
              <span v-if="scope.row.yw_open_app.length > 2">…</span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="status_text"
        label="处理状态"
        align="center"
      />
      <el-table-column
        align="center"
        prop="work_status"
        label="操作"
        fixed="right"
        width="300"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="edit(scope.row)"
          >绑定公众号</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="updatabawliwe(scope.row.audience_id)"
          >上传文件记录</el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteqw(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
    <el-dialog
      :title="'绑定公众号'"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="40%"
    >
      <readingbanddialog
        ref="readingcreateview"
        @updatawe="updatawe"
      />
    </el-dialog>
    <el-dialog
      title="批量修改记录"
      :visible.sync="upd_ad_log_visible"
      width="60%"
      :destroy-on-close="true"
    >
      <upd-ad-log />
    </el-dialog>
    <el-dialog
      title="上传文件记录"
      :visible.sync="dialogVisibleupdata"
      width="80%"
      :destroy-on-close="true"
    >
      <updatalist ref="updatadview" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { adaudienceindex, adaudienceupdate, adaudiencepull, audiencedelete } from '@/api/providerAccountManagement/servicePorviderList.js'
import readingbanddialog from './components/readingbanddialog.vue'
import UpdAdLog from './components/updAdLog.vue'
import updatalist from './components/updatalist.vue'
export default {
  components: {
    PaginationRight,
    readingbanddialog,
    UpdAdLog,
    updatalist
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        page_size: 10,
        name: null,
        audience_id: null
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      upd_ad_log_visible: false,
      dialogVisibleupdata: false
    }
  },
  created() {
    this.menuList()
  },
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await adaudienceindex(this.objr)
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    sraw() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.name = ''
      this.objr.audience_id = ''
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },

    async deleteItem() {
      this.$confirm('是否确定拉取人群包吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await adaudiencepull()
        this.menuList()
        this.$message({
          message: '拉取成功',
          type: 'success'
        })
      })
    },
    // 删除
    async deleteqw(id) {
      this.$confirm('是否删除人群包吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        await audiencedelete({ id: id })
        this.menuList()
        this.$message({
          message: '删除成功',
          type: 'success'
        })
      })
    },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    handleSwitchChange(newValue, id) {
      console.log('状态变了:', newValue, '对应ID:', id)
      adaudienceupdate({
        id: id,
        is_auth_exclude: newValue
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.menuList()
      })
    },
    getAppNames(apps) {
      return apps.map(app => app.app_name)
    },
    upbAdLog() {
      this.upd_ad_log_visible = true
    },
    updatabawliwe(audience_id) {
      this.dialogVisibleupdata = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.updatadview.send(audience_id)
      }, 100)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
